<template>
  <div class="image-text-setting">
    <ul class="editor-design">
      <li>
        レイアウト
      </li>
      <li class="flex-box" style="padding-top: 10px;">
        <!-- 画像数変更 -->
        <div v-if="showImagePartCount">
          <setting-select-box
            :value="imagePartCount"
            @changeCount="changeImagePartCount($event)"
          />
        </div>
        <!-- モバイル表示 -->
        <template v-if="partsContainerType === 'ImageText'">
          <div>
            <style-select-box
              :target="'flg-side'"
              :value="flgSide"
              :disabled="isflgSideDisabled"
              @updateStyles="updatePartsContainer($event)"
            />
          </div>
          <div>
            <setting-check-box
              :target="'flg_image_content_mobile_full_width'"
              :value="flgImageContentMobileFullWidth"
              @update="updatePartsContainer($event)"
            />
          </div>
        </template>
      </li>
      <li class="flex-box">
      <!-- レイアウト変更 -->
        <div>
          <setting-position
            :value="imagePosition"
            @updateImagePosition="updateImagePosition($event)"
            class="image-position"
          />
        </div>
        <!-- 垂直位置 -->
        <select-button
          :target="'vertical-align'"
          :value="partsContainerStyles['vertical-align']"
          @updateStyles="updateStyles($event)"
        />
      </li>
      <!-- 表示比率 -->
      <li class="flex-box" v-if="partsContainerType === 'ImageText' || partsContainerType === 'ImageCard'">
        <setting-ratio
          :value="horizontalDisplayRatio"
          :disabled="isSettingRatioDisabled"
          @updateHorizontalDisplayRatio="updateHorizontalDisplayRatio($event)"
        />
      </li>
      <!-- 上下余白 -->
      <li class="flex-box">
        <slider
          :prop="'padding-top'"
          :value="partsContainerStyles['padding-top']"
          @updateStyles="updatePartsContainerStyles($event)"
        />
      </li>
      <!-- 左右余白 -->
      <li class="flex-box">
        <slider
          :prop="'padding-right'"
          :value="partsContainerStyles['padding-right']"
          @updateStyles="updatePartsContainerStyles($event)"
        />
      </li>
      <!-- 間隔調整 -->
      <li class="flex-box" v-if="showSpacerWidth">
        <slider
          :prop="'spacer-width'"
          :value="spacerWidth"
          @updateStyles="updateSpacerSize($event)"
        />
      </li>
    </ul>
    <edit-parts-container-style
      :styles="partsContainerStyles"
      :sectionId="sectionId"
      :partsContainerId="partsContainerId"
      :partsContainerType="partsContainerType"
    />
  </div>
</template>

<script>
import EditPartsContainerStyle from '@/components/Content/Palette/EditPartDesign/Layouts/PartsContainerStyle'
import SettingSelectBox from '@/components/Content/Palette/CommonLayouts/EditSettingSelectBox'
import SettingCheckBox from '@/components/Content/Palette/CommonLayouts/EditSettingCheckBox'
import StyleSelectBox from '@/components/Content/Palette/CommonLayouts/EditStyleSelectBox'
import SettingPosition from '@/components/Content/Palette/EditPartDesign/Editor/ImageText/ImageTextSettingPosition'
import SettingRatio from '@/components/Content/Palette/EditPartDesign/Editor/ImageText/ImageTextSettingRatio'
import ImagePartBase from '@/components/Content/ImagePartBase'
import SelectButton from '@/components/Content/Palette/CommonLayouts/EditStyleSelectButton'
import Slider from '@/components/Content/Palette/CommonLayouts/EditStyleSlider'

export default {
  props: [
    'sectionId',
    'partsContainerId',
    'parts',
    'partsContainerType',
    'partsContainerStyles',
    'spacerParts',
    'flgSide',
    'flgImageContentMobileFullWidth',
  ],
  mixins: [
    ImagePartBase,
  ],
  components: {
    EditPartsContainerStyle,
    SettingSelectBox,
    SettingCheckBox,
    StyleSelectBox,
    SettingPosition,
    SettingRatio,
    SelectButton,
    Slider,
  },
  computed: {
    imagePartCount () {
      if (!this.parts) return null
      return this.parts.filter(part => part.type === 'Image').length
    },
    layoutType () {
      const partsContainer = this.$store.getters.findPartsContainer(this.sectionId, this.partsContainerId)
      if (!partsContainer) return null
      return partsContainer.layout_type
    },
    horizontalDisplayRatio () {
      const partsContainer = this.$store.getters.findPartsContainer(this.sectionId, this.partsContainerId)
      if (!partsContainer) return null
      return partsContainer.horizontal_display_ratio
    },
    showImagePartCount () {
      // 画像パーツ数変更：画像カードのみ非表示
      const partsContainer = this.$store.getters.findPartsContainer(this.sectionId, this.partsContainerId)
      if (!partsContainer) return null
      return partsContainer.type !== 'ImageCard'
    },
    // 画像枚数が2枚以上のみ表示
    showSpacerWidth () {
      if (!this.parts) return null
      const imageParts = this.parts.filter(part => part.type === 'Image')
      return imageParts.length > 1
    },
    spacerWidth () {
      if (!this.spacerParts) return null
      // スペーサーがない場合、スペーサーの大きさは0pxとする
      return this.spacerParts.length === 0 ? '0px' : this.spacerParts[0].attrs['width']
    },
    isflgSideDisabled () {
      const imageParts = this.parts.filter(part => part.type === 'Image')
      return imageParts.length === 1 && this.imagePosition.match(/^(Top|Bottom)$/)
    },
    isSettingRatioDisabled () {
      return (this.partsContainerType === 'ImageText' || this.partsContainerType === 'ImageCard') && this.imagePosition.match(/^(Top|Bottom)$/)
    },
  },
  methods: {
    // マルチcolumn row 画像パーツの、画像数を変更
    changeImagePartCount (event) {
      if (event.newValue > event.oldValue) {
        // カラムを増やす
        this.$store.dispatch('addMultiImagePart', {
          sectionId: this.sectionId,
          partsContainerId: this.partsContainerId,
          imagePosition: this.imagePosition,
          oldValue: event.oldValue,
          newValue: event.newValue,
        })
      } else if (event.oldValue > event.newValue) {
        // カラムを減らす
        this.$store.dispatch('deleteMultiImagePart', {
          sectionId: this.sectionId,
          partsContainerId: this.partsContainerId,
          oldValue: event.oldValue,
          newValue: event.newValue,
        })
        this.$emit('adjustCurrentTableId', 'DECREASE_COLUMN')
      }
      // 変更があったことを親コンポーネントに伝える
      this.$emit('updateImageText')
    },
    updateImagePosition (newPosition) {
      this.$store.dispatch('updateMultiImagePartPosition', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        imagePartCount: this.imagePartCount,
        newPosition: newPosition,
      })
      // 変更があったことを親コンポーネントに伝える
      this.$emit('updateImageText')
    },
    updateHorizontalDisplayRatio (newRatio) {
      this.$store.dispatch('updateMultiColumnHorizontalDisplayRatio', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        newRatio: newRatio,
      })
    },
    updateStyles (styles) {
      this.$store.commit('updatePartsContainerStyles', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        styles,
      })
    },
    updatePartsContainer (values) {
      this.$store.commit('updatePartsContainer', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        values,
      })
    },
    updatePartsContainerStyles (styles) {
      this.$store.dispatch('updateImagePartsContainerStyles', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        styles,
      })
    },
    updateSpacerSize (value) {
      this.spacerWidth === '0px' && this.$emit('adjustCurrentTableId', 'ADD_SPACER')
      value === '0px' && this.$emit('adjustCurrentTableId', 'DELETE_SPACER')

      this.$store.dispatch('updateImageTextSpacerSize', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        value,
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.image-position {
  margin-right: 20px;
}
</style>
